import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import PollsListing from 'views/admin/polling/PollsListing'

const Polls = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <PollsListing />
      </Route>
    </Switch>
  )
}

export default Polls
